import { render } from "./ProductListComponent.vue?vue&type=template&id=78976825"
import script from "./ProductListComponent.vue?vue&type=script&lang=js"
export * from "./ProductListComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\anygence\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__